<template>
  <div class="component-form">
    <h1 class="form-title">Seminar Outline</h1>
    <p class="text mt-30">
      A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document on Google Doc and
      replace all the highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing
      enabled) below so we can help edit and comment on the document.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload">Seminar Outline Template</Button>
    <p class="text mt-30 bold big">Please paste your outline sharing link here and click submit</p>
    <div class="inp-wrap large mt-20">
      <Input label="Http link" :value="value.link" @input="handleInput($event, 'link')" />
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import { Button, Input } from '../../../../components/form';
export default {
  name: 'SeminarOutline',
  components: {
    Button,
    Input
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen('https://docs.google.com/document/d/1_IJ52_dAN7AkEdchCS7gOQA4XuvoARwRCpvk3UgescM/edit?usp=sharing');
    }
  }
};
</script>
